import {Injectable} from '@angular/core';
import {TokenStorageService} from './token-storage.service';

/**
 * Rôle lecteur : consultation de toutes les pages admin, sans aucune modification.
 * Un utilisateur qui a aussi ROLE_ADMIN ou ROLE_SUPER_ADMIN garde ses droits d'écriture.
 */
@Injectable({
  providedIn: 'root'
})
export class ReadOnlyService {

  constructor(private tokenStorage: TokenStorageService) {
  }

  isReader(): boolean {
    return this.roles().includes('ROLE_READER');
  }

  isReadOnly(): boolean {
    const roles = this.roles();
    return roles.includes('ROLE_READER') && !roles.includes('ROLE_ADMIN') && !roles.includes('ROLE_SUPER_ADMIN');
  }

  hasRole(role: string): boolean {
    return this.roles().includes(role);
  }

  private roles(): string[] {
    return this.tokenStorage.getUser()?.roles ?? [];
  }
}
